// src/services/auth.js - UPDATED VERSION
import axios from 'axios'

export const authService = {
  /**
   * Validate API key by calling health endpoint
   */
  validateApiKey: async (credentials) => {
    try {
      const response = await axios.get(`${credentials.baseUrl}/health/`, {
        headers: {
          'x-api-key': credentials.apiKey
        },
        timeout: 5000
      })

      if (response.status === 200) {
        return {
          success: true,
          user: {
            name: 'API User',
            role: 'viewer'
          }
        }
      }

      return { success: false, error: 'Invalid response' }
    } catch (error) {
      console.error("AuthService Error:", error)
      let errorMessage = 'Authentication failed'

      if (error.code === 'ECONNABORTED') {
        errorMessage = 'Connection timeout. Please check the base URL.'
      } else if (error.response?.status === 401) {
        errorMessage = 'Invalid API key.'
      } else if (error.response?.status === 404) {
        errorMessage = 'API endpoint not found. Please check the base URL.'
      } else if (error.code === 'ECONNREFUSED') {
        errorMessage = 'Connection refused. Is the server running?'
      }

      throw new Error(errorMessage)
    }
  },

  /**
   * Login with username and password (JWT authentication)
   */
  loginWithPassword: async (credentials) => {
    try {
      // Create form data for OAuth2 password flow
      const formData = new URLSearchParams()
      formData.append('username', credentials.username)
      formData.append('password', credentials.password)

      const response = await axios.post(
        `${credentials.baseUrl}/auth/login`,
        formData,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          timeout: 5000
        }
      )

      if (response.status === 200 && response.data.access_token) {
        return {
          success: true,
          token: response.data.access_token,
          tokenType: response.data.token_type,
          expiresIn: response.data.expires_in,
          user: response.data.user
        }
      }

      return { success: false, error: 'Invalid response' }
    } catch (error) {
      console.error("Password Login Error:", error)
      let errorMessage = 'Login failed'

      if (error.code === 'ECONNABORTED') {
        errorMessage = 'Connection timeout. Please check the server URL.'
      } else if (error.response?.status === 401) {
        errorMessage = 'Incorrect username or password.'
      } else if (error.response?.status === 404) {
        errorMessage = 'Login endpoint not found. Please check the server URL.'
      } else if (error.code === 'ECONNREFUSED') {
        errorMessage = 'Connection refused. Is the server running?'
      } else if (error.response?.data?.detail) {
        errorMessage = error.response.data.detail
      }

      throw new Error(errorMessage)
    }
  },

  /**
   * Validate JWT token
   */
  validateToken: async (baseUrl, token) => {
    try {
      const response = await axios.post(
        `${baseUrl}/auth/validate-token`,
        { token },
        { timeout: 5000 }
      )

      return response.data.valid === true
    } catch (error) {
      console.error("Token Validation Error:", error)
      return false
    }
  },

  /**
   * Get current user info using JWT token
   */
  getCurrentUser: async (baseUrl, token) => {
    try {
      const response = await axios.get(
        `${baseUrl}/auth/me`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          timeout: 5000
        }
      )

      if (response.status === 200) {
        return {
          success: true,
          user: response.data
        }
      }

      return { success: false }
    } catch (error) {
      console.error("Get Current User Error:", error)
      return { success: false }
    }
  }
}
